import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { TrackingModule } from './tracking/tracking.module';
import { TrackingService } from './tracking/tracking.service';
import { HomeComponent } from './home/home.component';
import { LanguageComponent } from './language/language.component';
import { ReRouteComponent } from './re-route/re-route.component';
import { SearchFormLoadingComponent } from './search-form/search-form-loading/search-form-loading.component';
const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => TrackingModule,
  },
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
      initialNavigation: 'enabled',

      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
